import { gql } from '@apollo/client';

export const suppliersGql = gql`
  query Suppliers {
    suppliers {
      personId
      supplierName
    }
  }
`;
